import { store } from 'redux/store';

import { getDocumentBlob } from 'modules/_shared/components/CKEditor/utils/getDocumentBlob';
import { downloadBlob } from 'utils/downloadBlob';
import { getPartnersTableHtml } from 'modules/society/api/getPartnersTableHtml';
import { downloadExcelFromHtml } from 'utils/downloadExcelFromHtml';
import { formatNumber, formatNumberDecimals } from 'utils/formats';

type Formats = {
  pdf: boolean;
  excel: boolean;
};

type DownloadPartnersTableProps = {
  fileName: string;
  societyId: string;
  formats: Formats;
};

type DownloadFileProps = {
  data: string;
  fileName: string;
  formats: Formats;
};

const formatNumericValuesInHtml = (htmlString: string): string => {
  const regex = /(\d+(?:[\.,]\d+)?)(?=\s*(?:€|%|,|\s*<\/td>))/g; // eslint-disable-line

  const formattedHtml = htmlString.replace(regex, (match) => {
    const cleanMatch = match.replace(/[^\d.,-]/g, '').replace(',', '.');

    const num = parseFloat(cleanMatch);

    if (!isNaN(num)) {
      if (Number.isInteger(num)) {
        return formatNumber(num);
      }
      return formatNumberDecimals(num);
    }

    return match;
  });

  return formattedHtml;
};

const downloadExcel = async ({ data, fileName }: DownloadFileProps) => {
  downloadExcelFromHtml({
    htmlString: data || '',
    fileName: `${fileName}.xlsx`,
  });
};

const downloadPDF = async ({ data, fileName }: DownloadFileProps) => {
  const formattedHtml = formatNumericValuesInHtml(data || '');
  const blob = await getDocumentBlob({
    html: formattedHtml || '',
    isLandscape: true,
  });

  downloadBlob(blob, `${fileName}.pdf` || '');
};

const downloadFile = async ({ data, fileName, formats }: DownloadFileProps) => {
  if (formats?.excel) {
    await downloadExcel({ data, fileName, formats });
  }
  if (formats?.pdf) {
    await downloadPDF({ data, fileName, formats });
  }
};

export const downloadPartnersTable = async ({
  fileName,
  societyId,
  formats,
}: DownloadPartnersTableProps) => {
  const result = await store.dispatch(
    getPartnersTableHtml({
      societyId,
      language: 'es',
    })
  );

  await downloadFile({
    data: result,
    fileName,
    formats,
  });
};
